<template>
	<div class="toggle-button" :style="{marginRight: noLabel ? 0 : 12 + 'px'}">
		<div class="toggle">
			<div class="toggle-wrapper" :class="{reverse: reverseLayout}" :style="cssProps">
				<input type="checkbox" :checked="value" @change="onToggle()">
	
				<span @click="onToggle()" class="slider round" :class="value ? 'checked':''"></span>
				<label v-if="!noLabel" class="toggle-button-label" @click="onToggle()" v-html="text"></label>
				<!-- <label @click="onToggle()">{{text}}</label> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ToggleButton',
		props: {
            onToggleButton: Function,
            text: String,
			value: Boolean,
			reverseLayout: {
				type: Boolean,
				default: false
			},
			noLabel: Boolean,
			activeColor: {
				type: String,
				default: "var(--orange-web)"
			}
        },
        data(){
            return{
                toggled: false
            }
        },
		computed:{
			cssProps(){
				return {"--active-color": this.activeColor}
			}
		},
        methods:{
            onToggle(){
                this.toggled = !this.toggled
                this.onToggleButton()
            }  
        }
	}
</script>

<style lang="less">
	.toggle-button{
			display: flex;
			align-items: center;
			// padding: 10px 0;
			

			.toggle{
				position: relative;		
				.toggle-wrapper{
					display: flex;
					flex-direction: row;
					align-items: center;
					// justify-content: center;
				
				}
				.reverse{
					display: flex;
					flex-direction: row-reverse;
					align-items: center;
					gap: 12px;
				}
				label.toggle-button-label{
					margin:0;
					padding-left: 4px;
					// padding-top: 1px;
					cursor: pointer;
					
					font-size: 12px;
					line-height: 13px;
				}
				input {
					opacity: 0;
					width: 0;
					height: 0;
					pointer-events: none;
					position: absolute;
				}
				
				.slider{
					width: 24px;
					height: 14px;
					border-radius: 1px;
					color: #fafafa;
					position: relative;
					z-index: 99;
					cursor: pointer;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background-color: rgba(176, 179, 176, 0.144);
					-webkit-transition: .4s;
					transition: .4s;
					box-shadow: 0 0 3px rgba(0, 0, 0, 0.178);;
					&:before {
					position: absolute;
					content: "";
					height: 10px;
					width: 10px;
					left: 2px;
					bottom: 2px;
					border-radius: 1px;
					background-color: white;
					-webkit-transition: .4s;
					transition: .4s;
					}
				}
				input:checked + .slider {
					background-color: var(--active-color);
				}
				input:focus + .slider {
					box-shadow: 0 0 1px var(--active-color);
				}
				.checked {
					background-color: var(--active-color);
					box-shadow: 0 0 1px var(--active-color);
					
				
					&:before{	
						-webkit-transform: translateX(10px);
						-ms-transform: translateX(10px);
						transform: translateX(10px);
						}
				}
		


				input:checked + .slider:before {
				-webkit-transform: translateX(10px);
				-ms-transform: translateX(10px);
				transform: translateX(10px);
				}

				/* Rounded sliders */
				.slider.round {
					border-radius: 34px;
				}

				.slider.round:before {
					border-radius: 50%;
				}
			}
		}
</style>

